import AsyncStorage from '@react-native-async-storage/async-storage';
import {binaryToBase64} from '../../common/utils/image';
import {ImageBDL} from '../bdl/image';

interface CachedImage {
  fileName: string;
  base64: string;
}

export const ImageServices = () => {
  const {getUtilisateurImage} = ImageBDL();
  return {
    getUtilisateurImage: (fileName: string) => {
      return new Promise<string>(async resolve => {
        const storedData = await AsyncStorage.getItem('profileImage');
        const cachedImage: CachedImage = JSON.parse(storedData ?? '{}');

        if (cachedImage && cachedImage.fileName == fileName) {
          resolve(cachedImage.base64);
        } else {
          getUtilisateurImage(fileName)
            .then(res => {
              const base64 = binaryToBase64(res);
              // ASYNCSTORAGE LIMIT
              // try {
              //   AsyncStorage.setItem(
              //     'profileImage',
              //     JSON.stringify({fileName, base64}),
              //   ).then(() => resolve(base64));
              // } catch (error) {
              //   console.log(error);
              //   resolve(base64);
              // }
              resolve(base64);
            })
            .catch(err => console.log(err));
        }
      });
    },
    clearProfilePictureCache: async () =>
      await AsyncStorage.removeItem('profileImage'),
  };
};
